<script lang="ts">
    import { Col,Alert} from "sveltestrap";
    import { AlertIconMessage, AlertWithIconoutline } from "../../../utils/Constant/Constant";
    import FeatherIcon from "svelte-feather-icon";
    import Card from "../UiCommenCard.svelte";
    import data from "../../../Data/ComponentData/Ui-kits/Alert/Alert.json"
</script>
<Col sm="12" xl="6">
    <Card cardHeaderprops="pb-0" headerTitle={AlertWithIconoutline} headerContent={AlertIconMessage}>
      <div slot="contentbody">
        <Alert dismissible color="primary" class="outline">
            <FeatherIcon icon="clock" />
            <p>Your time Over after <b>5</b> miniute</p>
        </Alert>
        {#each data.AlertWithIconoutline as alertItem }
            <Alert dismissible color={alertItem.color} class="outline">
                <FeatherIcon icon={alertItem.icon} />
                <p>{alertItem.title}</p>
            </Alert>
        {/each}
      </div>
    </Card>
</Col>